import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { GlobalService } from 'app/shared/global.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgotPassword.component.html'
})

export class ForgotPasswordComponent implements OnInit {

    public loading = false;
    public isSent = false;

    @ViewChild('form') form: NgForm;

    constructor(
        private router: Router,
        private globalService: GlobalService,
        public angularFireAuth: AngularFireAuth,
        private route: ActivatedRoute) {
    }

    ngOnInit() {
    }

    onSubmit() {
        this.loading = true;

        this.angularFireAuth.auth.sendPasswordResetEmail(this.form.value.email).then((response) => {
            this.loading = false;
            this.isSent = true;
        }).catch((error) => {
            this.loading = false;
            console.error(error);

            if (error.code === 'auth/user-not-found') {
                this.globalService.handleError(new Error('Benutzer wurde nicht gefunden.'));
            }
        });
    }

    onBack() {
        this.router.navigate(['login'], { relativeTo: this.route.parent });
    }
}



// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotPassword.component.ts